import axios from 'axios'
import storage from '@/modules/storage'
import {
  clone,
  isObject,
} from 'lodash'
import Promise from 'bluebird'
import { print } from 'graphql'
const ignoredPaths = ['/login']
axios.defaults.baseURL = process.env.baseURL
axios.defaults.timeout = 30000

const stripTailingSlash = url => {
  return url.replace(/\/+$/g, '')
}

const embedToken = (config) => {
  if(!ignoredPaths.includes(config.url)) {
    const accessToken = storage.get('accessToken')
    config.headers['x-access-token'] = accessToken
  }

  return config
}

const authenticateUser = (error) => {
  if (!error.response) {
    error.response = { data : 'No response from backend server, ' +
      'please check your internet connection and try again later' }
  } else if (error.response.status === 401) {
    storage.removeAll()
   
  }

  return Promise.reject(error)
}


const createGqlClient = () => {
  const gqlClient = axios.create({
    baseURL : stripTailingSlash(process.env.VUE_APP_API_URL) + 
    '/api/graphql/'
  })
  
  gqlClient.interceptors.request.use(embedToken)
  gqlClient.interceptors.response
    .use(response => response, authenticateUser)

  return gqlClient
}

const gqlClient = createGqlClient()

class GraphqlClient {
  static query (param = null, data, config = {}) {
    if (isObject(param)) {
      if(isObject(data)) {
        config = data
      }
      data = clone(param)
      param = null
     
    } else if (!isObject(data)) {
      data = {}
    }
    
    data.query = data.mutation ? print(data.mutation) : print(data.query)

    return gqlClient.post(param, data,config)
  }
}

export default GraphqlClient
